// Subscriptions sold by the calendar month (Settings → "Subscriptions run by the month",
// setting `subscription_cutoff_day`). Same rule as server/src/services/monthTerms.js:
// a sign-up on or before the cut-off day gets next month's issue first, after it the
// month after; dates are stored 1st of the first month → last day of the last month.
import { useEffect, useState } from 'react';
import api from '../services/api';

export const MONTH_NAMES = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
const pad = (n) => String(n).padStart(2, '0');
const parts = (d) => String(d).slice(0, 10).split('-').map(Number);
const iso = (dt) => `${dt.getUTCFullYear()}-${pad(dt.getUTCMonth() + 1)}-${pad(dt.getUTCDate())}`;

export function cutoffDay(settings) {
  const n = parseInt(settings && settings.subscription_cutoff_day, 10);
  return n >= 1 && n <= 28 ? n : null;
}

/** 28 → "28th", 1 → "1st" */
export function ordinal(n) {
  const k = n % 100;
  return n + (k >= 11 && k <= 13 ? 'th' : ['th', 'st', 'nd', 'rd'][n % 10] || 'th');
}

/** Today here, YYYY-MM-DD */
export function todayIso() {
  const t = new Date();
  return `${t.getFullYear()}-${pad(t.getMonth() + 1)}-${pad(t.getDate())}`;
}

export function monthStart(d) { const [y, m] = parts(d); return `${y}-${pad(m)}-01`; }
export function monthEnd(d) { const [y, m] = parts(d); return iso(new Date(Date.UTC(y, m, 0))); }
export function addMonths(d, n) { const [y, m] = parts(d); return iso(new Date(Date.UTC(y, m - 1 + n, 1))); }

/** The first issue for a sign-up on `day` (default today) */
export function firstIssueMonth(cutoff, day = todayIso()) {
  return addMonths(day, parts(day)[2] <= cutoff ? 1 : 2);
}

/** The last month of a subscription of `months` whole months from `start` */
export function lastIssueMonth(start, months) { return addMonths(start, months - 1); }

/** "November 2027" ("Nov 2027" short) */
export function monthLabel(d, short) {
  const [y, m] = parts(d);
  return `${short ? MONTH_NAMES[m - 1].slice(0, 3) : MONTH_NAMES[m - 1]} ${y}`;
}

/** A stored date as the screen shows it: "November 2027" by the month, else 30/11/2027 */
export function showDate(d, cutoff) {
  if (!d) return '-';
  if (cutoff) return monthLabel(d);
  const [y, m, dd] = parts(d);
  return `${pad(dd)}/${pad(m)}/${y}`;
}

// The tenant's cut-off day, read once per page load (Settings → save forgets it)
let cached = null;
export function forgetMonthTerms() { cached = null; }
export function useCutoffDay() {
  const [cutoff, setCutoff] = useState(undefined); // undefined = not known yet
  useEffect(() => {
    if (!cached) cached = api.getSettings().then(cutoffDay).catch(() => null);
    let live = true;
    cached.then(c => { if (live) setCutoff(c); });
    return () => { live = false; };
  }, []);
  return cutoff;
}
